"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameViews = void 0;
var React = require("react");
var styles_1 = require("./styles");
exports.NameViews = function (props) {
    var name = props.name, activeImg = props.activeImg;
    return (React.createElement(styles_1.NameView, null, activeImg ? (React.createElement(React.Fragment, null,
        React.createElement(styles_1.OneLineName, null, name),
        React.createElement(styles_1.ActiveImg, { src: activeImg }))) : (React.createElement(styles_1.TwoLineName, null, name))));
};
